/* eslint-disable */
import { CircularProgress, Tooltip, FormControl, Select, OutlinedInput, MenuItem } from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import * as React from 'react'

import { EnhancedTableToolbar, getComparator, stableSort } from './stableSort'

import IconButton from '@mui/material/IconButton'
import { Button } from 'react-bootstrap'
import { useStates } from '../../../StateProvider'
import { GetEmulatorApi } from '../../../components/api/emulator'
import {
  EMULATOR_DELETE_URL,
  EMULATOR_URL,
  UPDATE_INTERVAL,
  USER_ASSIGN_EMULATOR_URL
} from '../../../constants'
import { useEmulatorStore } from '../../../stores/emulator/store.tsx'
import { CustomTablePagination } from '../../CustomTablePagination'
import ApiService from './../../../ApiService'

export default function EmulatorTable({
  handleAssignUserButtonClick,
  userAssingedEmulator,
  setUserAssingedEmulator,
  handleEmulatorTelephonePopup,
  emulatorEditedId,
  handleGeneratedIdButtonClick,
  emulatorData,
  updateSerial,
  handleCreateEmulator
}) {
  const { showToast } = useStates()
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('calories')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  const [emulators, setEmulators] = React.useState([])

  const [emulatorDetails, setEmulatorDetails] = React.useState()
  const [unassignEmulatorDetails, setUnassignEmulatorDetails] = React.useState()

  const totalEmulators = useEmulatorStore.getState().emulators
  const updateEmulators = useEmulatorStore((state) => state.updateEmulators)

  React.useEffect(() => {
    setEmulators(emulatorData)
  }, [emulatorData])

  React.useEffect(() => {
    if (emulatorEditedId != null) {
      if (emulatorEditedId === 0) {
        fetchData()
      } else {
        refreshEditedEmulator(emulatorEditedId)
      }
    }
  }, [emulatorEditedId])

  React.useEffect(() => {
    const updateSerialEmu = async () => {
      const { success, data } = await GetEmulatorApi()
      if (success) {
        setEmulators(data)
      }
    }
    updateSerialEmu()
  }, [updateSerial])

  // Fetch data from API
  const refreshEditedEmulator = async (emulatorEditedId) => {
    const token = localStorage.getItem('token')
    const { success, data, error } = await ApiService.makeApiCall(
      EMULATOR_URL,
      'GET',
      null,
      token,
      emulatorEditedId
    )
    if (success) {
      const updatedData = emulators.map((item) => {
        if (item.id === data.id) {
          return data
        }
        return item
      })
      // showToast('Updated Emulator table!', 'success')
      setEmulators(updatedData)
    } else {
      showToast('Failed to update Emulator table' + error, 'error')
      return { success: false, error: 'Failed to unassign user' }
    }
  }

  React.useEffect(() => {
    if (userAssingedEmulator != null) {
      const updatedData = emulators.map((item) => {
        if (item.id === userAssingedEmulator.id) {
          return { ...item, user: userAssingedEmulator.user }
        }
        return item
      })
      setEmulators(updatedData)
    }
  }, [userAssingedEmulator])

  // assign/unassign button
  const handleAssignButtonClick = async (row) => {
    if (row.user != null) {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(USER_ASSIGN_EMULATOR_URL + '/' + row.id, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })

        if (!response.ok || response.status !== 200) {
          showToast('Failed to unassign user', 'error')
          return { success: false, error: 'Failed to unassign user' }
        }
        // Send the removed user ID to refresh in user table
        const userAssignedEmulator = {
          user: {
            id: row.user?.id
          }
        }
        setUserAssingedEmulator(userAssignedEmulator)
        const updatedData = emulators.map((item) => {
          if (item.id === row.id) {
            return { ...item, user: null }
          }
          return item
        })
        showToast('User Un-Assigned', 'success')
        useEmulatorStore.getState().updateEmulators(updatedData)
        setEmulators(updatedData)
      } catch (error) {
        showToast(`Failed to unassign user ${error}`, 'error')
      }
    } else {
      handleAssignUserButtonClick(row)
    }
  }

  React.useEffect(() => {
    const unsubscribe = useEmulatorStore.subscribe(
      (newEmulators) => setEmulators(newEmulators.emulators),
      (state) => state.emulators
    )
    return () => unsubscribe()
  }, [])

  // Fetch data from API // GET  API
  const fetchData = async () => {
    setLoading(true)
    const { success, data, error } = await GetEmulatorApi()

    if (success) {
      setEmulators(data)
      updateEmulators(data)
      setLoading(false)
    } else {
      setError(error)
      setLoading(false)
    }
  }

  // delete button
  const handleDeleteButtonClick = async (emulator) => {
    const totalEmulators = useEmulatorStore.getState().emulators
    // const confirmed = window.confirm(
    //   'Delete this emulator : ' + emulator.emulatorSsid + '?'
    // )
    if (emulator?.emulatorSsid) {
      const token = localStorage.getItem('token')
      const { success } = await ApiService.makeApiCall(
        EMULATOR_DELETE_URL,
        'DELETE',
        null,
        token,
        emulator.id
      )

      if (success) {
        showToast('Emulator deleted', 'success')
        const updatedData = totalEmulators.filter(
          (item) => item.emulatorSsid !== emulator.emulatorSsid
        )
        useEmulatorStore.getState().updateEmulators(updatedData)
        fetchData()
      } else {
        showToast('Emulator not deleted', 'error')
      }
    }
  }

  React.useEffect(() => {
    setLoading(true)
    const { success, error } = fetchData()
    if (success) {
      showToast('Fetched Emulators successfully', 'success')
    } else {
      showToast(error, 'error')
    }
  }, [])

  React.useEffect(() => {
    if (userAssingedEmulator != null) {
      const updatedData = emulators.map((item) => {
        if (item.id === userAssingedEmulator.id) {
          return { ...item, user: userAssingedEmulator.user }
        }
        return item
      })
      setEmulators(updatedData)
      // showToast('Updated emulator table!', 'success')
    }
  }, [userAssingedEmulator])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const updateInterval = async (row, intervalVal) => {
    if (row.user != null) {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(`${UPDATE_INTERVAL(row.id, intervalVal)}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (response.ok || response.status == 200) {
          showToast('Interval updated successfully', 'success')
        }
      } catch (error) {
        console.error('updateInterval error: ', error)
        showToast(`Failed to update interval`, 'error')
      }
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - emulators.length) : 0

  const visibleRows = React.useMemo(
    () =>
      stableSort(totalEmulators, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, emulators, rowsPerPage]
  )

  if (error) {
    return (
      <>
        <div className="error">
          <h1>Something went wrong!</h1>
          <p>Error: {error}</p>
          <EnhancedTableToolbar handleOpen={handleCreateEmulator} />
        </div>
      </>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', marginBottom: 0 }}>
        <EnhancedTableToolbar handleOpen={handleCreateEmulator} />
        <TableContainer
          sx={{
            overflowX: 'auto',
            '&::-webkit-scrollbar': { height: '10px' },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#fffff',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#2C6FEB',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#2C6FEB' }
          }}
        >
          {loading ? (
            <div
              style={{
                textAlign: 'center',
                marginTop: '20vh',
                marginBottom: '20vh'
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="small"
              className="main-emulator-table"
            >
              <TableHead className="main-table-header">
                <TableRow>
                  {['Number', 'Assigned', 'SSID', 'Update Interval', 'Created', 'Status', 'Action'].map(
                    (header) => (
                      <TableCell
                        key={header}
                        className="table-header"
                        sx={
                          header === 'Action'
                            ? {
                                width: '80px',
                                minWidth: '80px',
                                textAlign: 'center',
                                fontFamily: '"Poppins", sans-serif !important',
                                fontWeight: '600 !important',
                                fontSize: '18px',
                                letterSpacing: '0rem'
                              }
                            : {
                                fontFamily: '"Poppins", sans-serif !important',
                                fontWeight: '600 !important',
                                fontSize: '18px',
                                letterSpacing: '0rem'
                              }
                        }
                      >
                        {header}
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((row, index) => {
                  const assigned = row.user !== null
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <TableCell className="table-cell table-id-font-alignment">
                        {page * rowsPerPage + index + 1}
                      </TableCell>

                      {/* Assigned Emulator */}
                      <TableCell className="table-cell">
                        {/* <Tooltip
                          title={`${row.user?.firstName || 'N/A'} ${row.user?.lastName || ''}`}
                          placement="top"
                        > */}
                        <div
                          style={{
                            maxWidth: '150px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                          className="emulator-table-content-font"
                        >
                          {row.user?.firstName || 'N/A'}{' '}
                          {row.user?.lastName || ''}
                        </div>
                        {/* </Tooltip> */}
                      </TableCell>

                      {/* SSID */}
                      <TableCell className="table-cell">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Tooltip
                            title={row.emulatorSsid || 'N/A'}
                            placement="top"
                          >
                            <div
                              style={{
                                maxWidth: '150px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              className="emulator-table-content-font"
                            >
                              {row.emulatorSsid || 'N/A'}
                            </div>
                          </Tooltip>
                          <IconButton
                            className="edit-button"
                            onClick={() => handleGeneratedIdButtonClick(row)}
                          >
                            <img src={'images/edit-icon.svg'} alt="edit-icon" />
                          </IconButton>
                        </div>
                      </TableCell>


                      {/* Update Interval */}
                      <TableCell className="table-cell">
                        <FormControl style={{ marginBottom: '5px' }}>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={row.updateInSec || 'N/A'}
                            onChange={(e) => {
                              const newInterval = e.target.value
                              updateInterval(row, newInterval)
                            }}
                            input={
                              <OutlinedInput
                                sx={{
                                  height: '36px',
                                  fontFamily: "'Poppins', sans-serif !important",
                                  fontWeight: '400 !important',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#ccc', // Default border color
                                    borderRadius: '4px',
                                    borderWidth: '0.3px'
                                  },
                                  '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#A3A3A3', // Border color on hover
                                    borderRadius: '4px',
                                    borderWidth: '0.3px'
                                  },
                                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#A3A3A3', // Border color on focus (click)
                                    borderRadius: '4px',
                                    borderWidth: '0.3px'
                                  },
                                  fontFamily: "'Poppins', sans-serif",
                                  fontSize: '16px'
                                }}
                              />
                            }
                            // MenuProps={MenuProps}
                          >
                            <MenuItem value={1}>1 Second</MenuItem>
                            <MenuItem value={5}>5 Seconds</MenuItem>
                            <MenuItem value={15}>15 Seconds</MenuItem>
                            <MenuItem value={30}>30 Seconds</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>

                      {/* Created At */}
                      <TableCell className="table-cell emulator-table-content-font">
                        {new Date(row.createdAt).toISOString().split('T')[0] ||
                          'N/A'}
                      </TableCell>

                      {/* Status */}
                      <TableCell className="table-cell emulator-table-content-font">
                        {row.status || 'N/A'}
                      </TableCell>

                      {/* Actions */}
                      <TableCell className="table-cell-for-action">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div
                            className={`assign-button ${assigned ? 'assigned' : 'unassigned'}`}
                            role="button"
                            tabIndex={0}
                            aria-label={assigned ? 'Unassign emulator' : 'Assign emulator'}
                            data-bs-toggle={assigned ? 'modal' : undefined}
                            data-bs-target={
                              assigned ? '#myModalUnassignEmulator' : undefined
                            }
                            onClick={() => {
                              if (assigned) {
                                setUnassignEmulatorDetails(row)
                                return
                              }
                              handleAssignButtonClick(row)
                            }}
                            onKeyDown={(e) => {
                              if (e.key !== 'Enter' && e.key !== ' ') return
                              e.preventDefault()
                              if (assigned) {
                                setUnassignEmulatorDetails(row)
                                return
                              }
                              handleAssignButtonClick(row)
                            }}
                          >
                            {assigned ? 'Unassign' : 'Assign'}
                            {assigned ? (
                              <IconButton
                                className="minus-bg icon-button"
                                tabIndex={-1}
                              >
                                <span id="alignAddBtn">
                                  <img
                                    src={'images/minus-icon.svg'}
                                    alt="minus-icon"
                                    width={13}
                                    height={27}
                                  />
                                </span>
                              </IconButton>
                            ) : (
                              <IconButton
                                className="add-bg icon-button"
                                tabIndex={-1}
                              >
                                <span id="alignAddBtn">
                                  <img
                                    src={'images/add-icon.svg'}
                                    alt="add-icon"
                                    width={13}
                                    height={27}
                                  />
                                </span>
                              </IconButton>
                            )}
                          </div>
                          <IconButton
                            className="delete-button"
                            data-bs-toggle="modal"
                            data-bs-target="#myModaDeleteEmulator"
                            onClick={() => setEmulatorDetails(row)}
                          >
                            <img
                              src={'images/delete-icon.svg'}
                              alt="delete-icon"
                            />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>
      <div className="alignPagination">
        <CustomTablePagination
          rowsPerPageOptions={[10, 30, 50]}
          count={emulators.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="" // Removes "Rows per page:"
          style={{ overflow: 'hidden' }}
        />
      </div>

      {/* Delete Emulator Modal */}
      <div className="modal" id="myModaDeleteEmulator">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">
                Delete Emulator
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to delete this emulator:{' '}
              {emulatorDetails?.emulatorSsid}?
            </div>

            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => handleDeleteButtonClick(emulatorDetails)}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="myModalUnassignEmulator">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">
                Unassign Emulator
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to unassign this emulator:{' '}
              {unassignEmulatorDetails?.emulatorSsid}?
            </div>

            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => {
                  if (unassignEmulatorDetails) {
                    handleAssignButtonClick(unassignEmulatorDetails)
                  }
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}
